<template>
  <div>
    <div class="question_bg">
      <div class="question_top_bg">

      </div>
      <div class="question_center_bg" v-if="!submitSuccess">
        <div class="content_box">
          <div class="content" v-for="(question, index) in filteredQuestions" :key="question.id">
            <div class="content_title_box">
              <div class="content_title">
                <p v-if="!question.hidden">{{ question.text }}{{question.progress}}</p>
              </div>
            </div>
            <div v-if="question.type === 'radio' && !question.hidden">
              <div class="content_check">
                <van-radio-group v-model="question.answer">
                  <van-radio v-for="(option, keys) in question.options" :key="keys" :name="option">{{ option }}</van-radio>
                </van-radio-group>
              </div>
              <div v-if="question.answer === '其他'">
                <van-field type="textarea" required v-model="question.conditionalAnswer" placeholder="请填写您的具体意见" />
              </div>
            </div>
            <div v-if="question.type === 'input' && !question.hidden">
              <van-field type="textarea" v-model="question.answer" :placeholder="question.text" />
            </div>
          </div>

          <div class="content_button">
            <van-button type="info" :disabled="!isNextButtonEnabled" @click="handleNextOrSubmit">{{ nextButtonText }}</van-button>
          </div>
          <div class="content_special_button" v-if="isSubmitButton">
            <van-button type="info" @click="submitSurvey(1)">匿名提交</van-button>
          </div>
        </div>
        <div class="question_info" @click="questionOut">
          <p>退出问卷</p>
        </div>
      </div>
      <div class="success_center_bg" v-if="submitSuccess">
        <div class="success_img">
          <img width="120" height="120" src="../../assets/images/success_icon.png" />
        </div>
        <div class="success_content">
          <p>问卷提交成功！</p>
          <p>感谢您的参与</p>
        </div>
        <div class="success_back" @click="out_sub">
          <van-button type="info">返回首页</van-button>
        </div>
      </div>
    </div>
    <div class="out_box" v-if="outShow">
      <div class="out_content_box">
        <div class="out_content">
          <p>确定退出？</p>
          <p>退出不能再次参与调研</p>
          <div class="out_button">
            <div class="out_cancel" @click="out_cancel"><van-button type="info">取消</van-button></div>
            <div class="out_sub" @click="out_sub"><van-button type="info">退出</van-button></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { GetQuestion } from "@/api/bill";
import qs from "qs";
export default {
  data() {
    return {
      token: '',
      // 定义问卷问题数组
      questions: [
        {
          id: 1,
          text: '21°网上商城诚邀您对亲子采摘活动提出宝贵意见或者建议，大约耽误您1-2分钟，是否开启问卷？',
          progress: '【共8小题】',
          type: 'radio',
          options: ['是', '否'],
          answer: null,
          hidden: false,
        },
        {
          id: 2,
          text: '1、您和孩子参加亲子采摘活动的频率是多久一次？',
          progress: '【1/8】',
          type: 'radio',
          options: ['每周一次', '每月一次', '半年一次', '一年一次或更少'],
          answer: null,
          hidden: true,
        },
        {
          id: 3,
          text: '2、您希望采摘活动的时间长度是多久？',
          progress: '【2/8】',
          type: 'radio',
          options: ['1-2 小时', '2-3 小时', '3-4 小时', '4 小时以上'],
          answer: null,
          hidden: true,
        },
        {
          id: 4,
          text: '3、您更喜欢在什么季节进行亲子采摘？',
          type: 'radio',
          progress: '【3/8】',
          options: ['春季', '夏季', '秋季', '冬季'],
          answer: null,
          hidden: true,
        },
        {
          id: 5,
          text: '4、您能接受的采摘价格？（采摘价格与采摘成本相关）',
          progress: '【4/8】',
          type: 'radio',
          options: ['60元及以下', '60元-100元', '100元-200元', '200元以上'],
          answer: null,
          hidden: true,
        },
        {
          id: 6,
          text: '5、您希望采摘活动中提供哪些设施或服务？',
          progress: '【5/8】',
          type: 'radio',
          options: ['休息区', '拍照留念的场景布置', '游乐设施', '其他'],
          answer: null,
          conditionalAnswer: '',
          hidden: true,
        },
        {
          id: 7,
          text: '6、您希望多增加什么活动内容？',
          progress: '【6/8】',
          type: 'radio',
          options: ['亲子互动游戏', '手工DIY美食', '园艺/种植讲解', '其他'],
          answer: null,
          conditionalAnswer: '',
          hidden: true,
        },
        {
          id: 8,
          text: '7、在采摘过程中，您是否遇到过什么问题或不便之处？（选填）',
          progress: '【7/8】',
          type: 'input',
          answer: '',
          hidden: true,
          required: false,
        },
        {
          id: 9,
          text: '8、您对亲子采摘活动还有哪些其他建议或期望？（选填）',
          progress: '【8/8】',
          type: 'input',
          answer: '',
          hidden: true,
          required: false,
        }
      ],
      currentQuestionIndex: 0,
      submitSuccess: false,
      outShow: false,
      isSubmitting: false,
    };
  },
  mounted() {
    // 组件挂载后执行，从路由查询参数中获取token
    this.token = this.$route.query.token
  },
  computed: {
    filteredQuestions() {
      // 根据当前问题的索引和其他条件动态过滤和修改问题列表
      return this.questions.map(question => {
        question.hidden = this.currentQuestionIndex !== (question.id - 1);
        return question;
      }).filter(q => !q.hidden);
    },
    currentQuestion() {
      // 返回当前问题的对象
      return this.questions[this.currentQuestionIndex];
    },
    nextButtonText() {
      // 根据当前问题和答案动态设置下一个按钮的文本
      if (this.currentQuestionIndex === 0) {
        return this.currentQuestion.answer ? (this.currentQuestion.answer === '否' ? '提交问卷' : '下一个') : '下一个';
      } else if (this.currentQuestionIndex === 8) {
        return '提交问卷';
      }
      return '下一个';
    },
    isNextButtonEnabled() {
      // 判断下一个按钮是否可用（当前问题是否已回答）
      const currentQuestion = this.questions[this.currentQuestionIndex];
      if (currentQuestion.type === 'radio') {
        if (currentQuestion.answer === '其他') {
          return currentQuestion.conditionalAnswer.trim() !== '';
        }
        return currentQuestion.answer !== null;
      }
      return true;
    },
    isSubmitButton() {
      // 判断当前是否应该显示提交按钮
      return this.currentQuestionIndex === 8;
    },
  },
  methods: {
    handleNextOrSubmit() {
      // 根据当前状态处理下一个问题或提交问卷
      if (this.currentQuestionIndex === 0 && this.currentQuestion.answer === '否') {
        this.submitSurvey(0);
        return;
      }
      if (this.nextButtonText === '提交问卷') {
        this.submitSurvey(0);
      } else {
        this.nextQuestion();
      }
    },
    nextQuestion() {
      // 切换到下一个问题
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex++;
        // if (this.currentQuestionIndex === 1) {
        //   this.questions[0].hidden = this.questions[0].answer === '不满意';
        // }
      }
    },
    questionOut(){
      // 控制退出元素的显示
      this.outShow = true
    },
    out_cancel(){
      // 控制退出元素的显示
      this.outShow = false
    },
    out_sub(){
      // 返回或退出,判断android与ios关闭
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isAndroid){
        // android
        // android的返回函数showInfoFromJs
        window.AndroidWebView.showInfoFromJs('close')
      }
      if(isiOS){
        // IOS
        // IOS的返回函数showMessage
        window.webkit.messageHandlers.showMessage.postMessage('close');
      }
    },
    submitSurvey(is_niming) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const surveyData = this.questions
          .filter(q => {
            // 当第一个问题选择"否"时，只保留第一个问题
            if (this.questions[0].answer === '否') {
              return q.id === 1;
            }
            // 否则按原逻辑过滤
            return q.answer !== null || (q.type === 'input' && q.answer !== '');
          })
          .map(question => {
            let intro = '';
            // 处理问题六和问题七的"其他"选项
            if ((question.id === 6 || question.id === 7) && question.answer === '其他') {
              intro = question.conditionalAnswer;
            }
            return {
              question: question.text,
              answer: question.answer || question.conditionalAnswer || '',
              intro: intro
            };
          });

      let params = {
        token: this.token,
        is_niming: is_niming,
        content: surveyData
      };
      // 添加 Authorization 参数到 headers 中
      const config = {
        headers: {
          'Authorization': this.token // 替换为实际的授权令牌
        }
      };
      GetQuestion(params,config).then((res) => {
        let { code, data, message } = res;
        this.isSubmitting = false;
        if (code != 0) return this.$toast(message || "请求错误");
        this.submitSuccess = true;
      }).catch((error) => {
        this.isSubmitting = false;
        this.$toast('提交失败，请稍后再试');
      });
    },
  },
};
</script>

<style scoped>
.question_bg{background: #A2C4FF;min-height: 100vh;padding-bottom: 50px;}
.question_top_bg{width: 100%;height: 280px;background-image: url("../../assets/images/question_top_bg_1.png");background-repeat: no-repeat;background-position: center;background-size: cover;}
.question_center_bg{width: 349px;min-height: 469px;padding-bottom: 20px;background-size: 100% 100%;background-repeat: no-repeat;margin: -30px auto 0;padding-top: 1px;background-image: url("../../assets/images/question_center_bg.png");}
.success_center_bg{width: 345px;height: 388px;background: #FFFFFF;border-radius: 20px;margin: -30px auto 0;padding-top: 1px;}
.special_question_center_bg{width: 349px;min-height: 540px;background-size: 100% 100%;background-repeat: no-repeat;margin: -30px auto 0;padding-top: 1px;background-image: url("../../assets/images/question_center_bg.png");}
.content_title_box{width: 300px;margin: 25px auto 0;padding: 2px 15px;background: linear-gradient( 270deg, #FFFFFF 0%, #E0E9FF 100%);}
.content_title{font-weight: 600;font-size: 16px;color: #050505;line-height: 24px;text-align: left;}
.content_check{width: 278px;font-weight: 600;font-size: 16px;color: #050505;line-height: 24px;margin: 25px auto;}
.question_subform{width: 278px;font-weight: 600;font-size: 16px;color: #050505;line-height: 24px;margin: 25px auto;}
.special_question_subform{width: 278px;font-weight: 600;font-size: 16px;color: #050505;line-height: 24px;margin: 15px auto;}
.van-radio{margin: 35px 0 0;}
.special_check .van-radio{margin: 25px 0 0;}
.van-field{margin: 0 auto;width: 275px;height: 80px;background: #FAFAFA;border-radius: 8px;border: 1px solid #DCDDDE;}
.question_center_bg .van-button{display: block;width: 211px;height: 50px;margin: 70px auto 30px;color: #fff;font-size: 16px;
  }
.content_button .van-button{margin: 70px auto 30px;background: #4851F6;box-shadow: inset 0px -2px 0px 0px #85B0FF;border-radius: 30px;}
.content_special_button .van-button{margin: 0 auto 30px;background: #F4F5FF;border-radius: 30px;border: 1px solid #4851F6;color: #4851F6;}
.special_question_subform .van-button{margin: 18px auto 10px;}
.question_info{font-weight: 400;font-size: 14px;color: #7B9CC7;text-align: center;}
.van-field{margin-top: 30px;}
.success_img{padding-top: 40px;text-align: center;}
.success_content{text-align: center;}
.success_content p:first-child{font-weight: 600;font-size: 20px;color: #3BCFA8;line-height: 20px;}
.success_content p:last-child{font-weight: 500;font-size: 16px;color: #8E8E8E;line-height: 16px;}
.success_back{padding-top: 35px;text-align: center;}
.success_back .van-button{border:none;margin: 0 auto;width: 211px;height: 50px;background: linear-gradient( 135deg, #FFB235 0%, #FFCF62 100%);box-shadow: 0px 2px 4px 0px #FDD37A, inset 0px -3px 0px 0px #FEE4B9;border-radius: 30px;}
.out_box{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;right: 0;top: 0;bottom: 0;
  background: rgba(30,30,30,.5);
  z-index:1
}
.out_content_box{
  position: relative;
}
.out_content{
  position: absolute;
  left: 40px;
  top: 200px;
  width: 231px;
  padding: 24px 32px;
  background: linear-gradient( 180deg, #FFFFFF 0%, #F3F7FF 100%);
  box-shadow: 0px 2px 4px 0px rgba(53,53,53,0.06);
  border-radius: 8px;
  text-align: center;
  border: 2px solid #FFFFFF;
}
.out_content p{
  margin: 20px 0;
}
.out_content p:first-child{
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  line-height: 16px;
}
.out_content p:last-child{
  font-size: 14px;
  color: #000000;
  line-height: 14px;
}
.out_button{
  display: flex;justify-content: space-between
}
.out_cancel .van-button{
  width: 92px;
  height: 38px;
  line-height: 38px;
  background: #F4F5FF;
  border-radius: 30px;
  border: 1px solid #4851F6;
  font-weight: 500;
  font-size: 14px;
  color: #4851F6;
  text-align: center;
}
.out_sub .van-button{
  width: 92px;
  height: 38px;
  line-height: 38px;
  background: #4851F6;
  box-shadow: inset 0px -2px 0px 0px #85B0FF;
  border-radius: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
}
</style>
